import React from "react";
import { SessionWithUsers } from "src/features/sessions/types";
import { TransactionTableWithUsers } from "src/features/users-transactions/components/transaction-table-with-users";
import { UserTransaction } from "src/features/users-transactions/types/user-transaction.entity";

type Props = {
  users: SessionWithUsers["users"];
  transactions: UserTransaction[];
};
export const TransactionsSection: React.FC<Props> = ({ users, transactions }) => {
  const excludeRefundForUsersIds = Object.keys(users).filter((key) =>
    transactions.find((t) => t.userId == key && t.label == "ADMIN_SESSION_REFUND")
  );
  return (
    <TransactionTableWithUsers
      transactions={transactions}
      users={users}
      showRefundAction={true}
      excludeRefundForUsersIds={excludeRefundForUsersIds}
    />
  );
};
